import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DepartamentosService } from 'src/app/servicios/departamentos.service';
import { CiudadesService } from 'src/app/servicios/ciudades.service';
import { DireccionService } from 'src/app/servicios/direccion.service';


@Component({
  selector: 'app-modificar-direccion-persona',
  templateUrl: '././modificar-direccion-persona.component.html',
  styleUrls: ['././modificar-direccion-persona.component.css']
})
export class ModificarDireccionPersonaComponent implements OnInit {

  @Output()
  propagar = new EventEmitter<string>();

  @Input() dataModificaDireccion: any;
  direccionGroup: FormGroup;
  departamentos = [];
  ciudades = [];
  loadingDireccion = false;

  constructor(
    private fb: FormBuilder,
    private servicioDepartamento: DepartamentosService,
    private ciudadService: CiudadesService,
    private servicioDireccion: DireccionService,
    private snackBar: MatSnackBar
  ) {
    this.direccionGroup = this.fb.group({
      NombreDireccion:[''],
      IdPersContacto: [''],
      Telefono: ['', [Validators.required, Validators.maxLength(20)]],
      Telefono2: ['', [Validators.maxLength(20)]],
      idDepto: [''],
      idMunicipio: ['', [Validators.required]],
      Direccion: ['', [Validators.required, Validators.maxLength(20)]],
      Observacion: ['']
    });
  }

  ngOnInit() {
    console.log(this.dataModificaDireccion);
    this.refreshData();
  }

  ngOnChanges() {
    this.refreshData();
  }

  setValuesForm() {

    this.direccionGroup.controls['NombreDireccion'].setValue(
      this.dataModificaDireccion.NombreDireccion
    );
    this.direccionGroup.controls['idDepto'].setValue(
      this.dataModificaDireccion.idDepto
    );
    this.direccionGroup.controls['idMunicipio'].setValue(
      this.dataModificaDireccion.idMunicipio
    );
    this.direccionGroup.controls['Direccion'].setValue(
      this.dataModificaDireccion.Direccion
    );
    this.direccionGroup.controls['Telefono'].setValue(
      this.dataModificaDireccion.Telefono
    );
    this.direccionGroup.controls['Telefono2'].setValue(
      this.dataModificaDireccion.Telefono2
    );
    this.direccionGroup.controls['Observacion'].setValue(
      this.dataModificaDireccion.Observacion
    );
  }

  refreshData() {
    this.loadingDireccion = true;
    this.servicioDepartamento.getDepartamentos().subscribe(data => {
      this.departamentos = data;
      console.log(JSON.stringify(this.departamentos));
      this.ciudadService
        .getCiudades(this.dataModificaDireccion.idDepto)
        .subscribe(result => {
          this.loadingDireccion = false;
          this.ciudades = result;
          this.setValuesForm();
        });
    });
  }

  submitForm() {
    let direccion = this.direccionGroup.value;
    direccion.IdPersContacto=this.dataModificaDireccion.IdPersonaDireccion;
    //console.log(JSON.stringify(direccion));
    direccion.Direccion = direccion.Direccion.toUpperCase();
    direccion.Observacion = direccion.Observacion.toUpperCase();
    this.servicioDireccion.putDireccion(direccion).subscribe(result => {
      this.propagar.emit(this.dataModificaDireccion);
      this.snackBar.open('Dirección Actualizada', 'Actualizar Dirección', {
        duration: 2000
      });
    });
  }
}
